import { configure } from 'vee-validate';

// Configure VeeValidate globally
configure({
  // Generate error messages from validation rules
  generateMessage: (ctx) => {
    const messages = {
      required: 'Este campo é obrigatório',
      email: 'Este campo deve ser um email válido',
      min: `Este campo deve ter pelo menos ${ctx.rule.params?.[0] || '{length}'} caracteres`,
      max: `Este campo deve ter no máximo ${ctx.rule.params?.[0] || '{length}'} caracteres`,
      numeric: 'Este campo deve ser um número',
      integer: 'Este campo deve ser um número inteiro',
      min_value: `Este campo deve ser pelo menos ${ctx.rule.params?.[0] || '{min}'}`,
      max_value: `Este campo deve ser no máximo ${ctx.rule.params?.[0] || '{max}'}`,
      confirmed: 'Este campo deve coincidir',
      regex: 'Este campo tem um formato inválido',
      oneOf: `Este campo deve ser um dos seguintes valores: ${ctx.rule.params?.join(', ') || '{values}'}`,
      length: `Este campo deve ter ${ctx.rule.params?.[0] || '{length}'} caracteres`
    };

    return messages[ctx.rule.name] || `${ctx.field} é inválido`;
  },

  // Validate on input change
  validateOnInput: true,

  // Validate on blur
  validateOnBlur: true,

  // Validate on value change
  validateOnChange: true,

  // Validate on mount
  validateOnMount: false
});

export default configure;